module.exports = __webpack_public_path__ + "img/city@2x.f869776.jpg";